// extracted by mini-css-extract-plugin
module.exports = {"manually":"Footer_manually__3cHHP","manuallyBtn":"Footer_manuallyBtn__ZHxta"};